import React, { useContext, useState } from 'react';
import { Item, Button, Label, Segment, Table, Menu, Icon, Confirm, Container, Popup } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import SiteVodafoneStore from '../../../app/stores/sitevodafoneStore';
import { Link } from 'react-router-dom';

const SiteVodafoneList: React.FC = () => {
  const sitevodafoneStore = useContext(SiteVodafoneStore);
  const {sitevodafonenamesByDate: sitevodafonenamesByDate,  
    deleteSiteVodafone: deleteSiteVodafone, submitting, target} = sitevodafoneStore;

  return (

      <Table celled>
    <Table.Header>
      <Table.Row>
      <Table.HeaderCell>Site ID</Table.HeaderCell>
      <Table.HeaderCell>Site Name</Table.HeaderCell>
        <Table.HeaderCell>Direct Access</Table.HeaderCell>
        <Table.HeaderCell>Address</Table.HeaderCell>
        <Table.HeaderCell>City</Table.HeaderCell>
        <Table.HeaderCell>State</Table.HeaderCell>
        <Table.HeaderCell width={1}>Action</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
    {sitevodafonenamesByDate.map(sitevodafone => (
     <Table.Row key={sitevodafone.id}> 
    <Table.Cell>{sitevodafone.siteID_c}</Table.Cell> 
        <Table.Cell>{sitevodafone.siteName}</Table.Cell> 
        <Table.Cell>{sitevodafone.direct_Access}</Table.Cell> 
        <Table.Cell>
          {sitevodafone.address}
          <Popup
            content="Open in google map"
            trigger={
            <a href={`https://maps.google.com/?q=${sitevodafone.address}`} target="_Blank">
            <Icon name='map marker alternate' size='large'/>
            </a>
            }
          />
        </Table.Cell> 
        <Table.Cell>{sitevodafone.city}</Table.Cell> 
        <Table.Cell>{sitevodafone.stateOrProvince}</Table.Cell> 
        <Table.Cell>
        <Button.Group size='mini'>              
                <Button
                  as={Link}
                  to={`/projectmanagement/sitevodafone/${sitevodafone.id}`}
                  size='mini'
                  content='View'
                  color='blue'
                />         
                
          </Button.Group>
        </Table.Cell>
      
      </Table.Row> 
    ))}
    </Table.Body>
  </Table>

  );
};

export default observer(SiteVodafoneList);
